module.exports = __webpack_public_path__ + "img/PXL_20230526_083720424.79388b04.jpg";